import HomeDescription from './HomeDescription';

export default HomeDescription;
